import { Swiper, SwiperSlide } from 'swiper/react';
import { useProductImages } from '../hooks/useProductImages';
import ThumbImg from './ThumbImg';

const navigationConfig = {
	prevEl: '.swiper-thumbnails-caret-prev',
	nextEl: '.swiper-thumbnails-caret-next',
	disabledClass: `c-disabled o-0 pointer-events-none`,
	hiddenClass: 'dn',
};

type ProductImagesThumbProps = {
	thumbController: any;
	images: any;
};

const ProductImagesThumb = ({ images, thumbController }: ProductImagesThumbProps) => {
	const {
		blockClass,
		thumbnailsOrientation = 'vertical',
		thumbnailMaxHeight,
		displayThumbnailsArrows,
	} = useProductImages();

	const renderClass = () => {
		return blockClass && `vtex-store-components-3-x-productImagesThumb--${blockClass}`;
	};

	const renderTokens = () => {
		if (thumbnailsOrientation === 'horizontal') {
			return 'w-20';
		}

		return 'w-100';
	};

	return (
		<Swiper
			onSwiper={thumbController}
			className={`h-100`}
			slidesPerView="auto"
			touchRatio={1}
			threshold={8}
			navigation={navigationConfig}
			slidesPerGroup={displayThumbnailsArrows ? 4 : 1}
			freeMode={false}
			mousewheel={false}
			zoom={false}
			watchSlidesProgress
			preloadImages
			updateOnWindowResize
			direction={thumbnailsOrientation}
		>
			{images.map((img: any, index: any) => (
				<SwiperSlide
					className={`productImagesThumb productImagesThumb--${blockClass} vtex-store-components-3-x-productImagesThumb ${renderClass()} mb5 pointer ${renderTokens()} ${index === 0 && 'vtex-store-components-3-x-productImagesThumbActive'}`}
					style={{
						height: thumbnailsOrientation === 'vertical' ? 'auto' : '115px',
						maxHeight: thumbnailMaxHeight || 'unset',
						position: 'relative',
					}}
					key={`thumb-${index}`}
				>
					<figure className={`vtex-store-components-3-x-figure`}>
						<ThumbImg src={img} />
					</figure>
					<div className="absolute absolute--fill b--solid b--muted-2 bw0 vtex-store-components-3-x-carouselThumbBorder"></div>
				</SwiperSlide>
			))}
		</Swiper>
	);
};

export default ProductImagesThumb;
